import React, { ReactNode } from 'react'
import Layout from '../components/layout'
import Styles from '../styles'
import SEO from '../components/seo'
// @ts-ignore
import { MDXProvider } from '@mdx-js/react'
import Code from '../components/code'
import FloatingLinks from '../components/floating-links'

import { DidomiSDK } from '@didomi/react'

const BaseLayout = ({
    children,
    withSidebar = false,
    hasLogin = false,
}: {
    children: ReactNode
    withSidebar?: boolean
    hasLogin?: boolean
}) => (
    <MDXProvider components={{ code: Code }}>
        <FloatingLinks />
        <DidomiSDK
            apiKey="8878f527-7872-49a5-abd4-f6b2e56cb64a"
            iabVersion={2}
            noticeId="CnUtpQ7h"
            gdprAppliesGlobally={true}
        />
        <Styles />
        <SEO title={'GIPHY Developers'} />
        <Layout withSidebar={withSidebar} hasLogin={hasLogin}>
            {children}
        </Layout>
    </MDXProvider>
)

export default BaseLayout
